import PageMain from '../../components/Navigation/PageMain/PageMain';
import ChangePassword from '../../components/Settings/ChangePassword/ChangePassword';
import { RequestStatus } from '../../sic-lib/enums/RequestStatus';
import { useAppSelector } from '../../store/hooks';

const ChangePasswordPage = () => {
    const statusRequest = useAppSelector(state => {
        return state.user?.requestStatus || RequestStatus.none;
    });

    return (
        <PageMain
            pageTitle="Change Password"
            showError={statusRequest === RequestStatus.error}
            showLoading={false}
            // showLoading={statusRequest !== RequestStatus.success}
        >
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <ChangePassword />
                </div>
            </div>
        </PageMain>
    );
};

export default ChangePasswordPage;
